<div class="appearance-section">
  <pdq-collapsed class="appearance-collapse" [initialCollapsed]="false">
    <pdq-collapsed-header arrowStyle="chevron">
      <pdq-heading element="h6">Appearance</pdq-heading>
    </pdq-collapsed-header>
    <pdq-collapsed-content>
      <pdq-divider class="appearance-collapse__divider"></pdq-divider>
      <div class="appearance-collapse__body">
        <div class="appearance-group">
          <p class="appearance-group__title">Product display type</p>
          <div class="tab-menu">
            @for (option of displayTypeOptions; track option.value) {
              <button
                type="button"
                class="tab-menu__item"
                [class.tab-menu__item--active]="formGroup.get('style.displayType')?.value === option.value"
                (click)="setDisplayType(option.value)">
                <pdq-icon [icon]="option.icon" size="small"></pdq-icon>
                <span>{{ option.text }}</span>
              </button>
            }
          </div>
        </div>

        <pdq-divider></pdq-divider>

        @if (formGroup.get('style.displayType')?.value === 'cards') {
          <div class="appearance-group">
            <p class="appearance-group__title">Navigation Style</p>
            <pdq-radio-group [formControl]="formGroup.get('style.carouselNavigationStyle')">
              @for (option of carouselNavigationStyleOptions; track option.value) {
                <pdq-radio-button
                  [value]="option.value"
                  [checked]="formGroup.get('style.carouselNavigationStyle')?.value === option.value"
                  [text]="option.text"
                  [subText]="option.description">
                </pdq-radio-button>
              }
            </pdq-radio-group>
          </div>
        }

        @if (formGroup.get('style.displayType')?.value === 'row') {
          <pdq-input-arrows
            [formControl]="formGroup.get('style.numberOfRowsInRowDisplayType')"
            label="Number of rows"
            [min]="1"
            [max]="5"
            [precision]="0"
            [step]="1"
            widthSize="auto">
          </pdq-input-arrows>
        }

        <div class="appearance-group">
          <p class="appearance-group__title appearance-group__title--medium">Section Title</p>
          <rich-textarea
            [initialContent]="formGroup.get('settings.sectionTitle')?.value"
            placeholder="You may also like"
            [enableLinkInsert]="true"
            (contentChange)="formGroup.get('settings.sectionTitle')?.setValue($event)">
          </rich-textarea>
          <pdq-input-color
            [formControl]="formGroup.get('settings.sectionTitleColor')"
            label="Text Color"
            [clearable]="true"
            clearTooltip="Use the theme's colour"
            (cleared)="formGroup.get('settings.sectionTitleColor')?.setValue('')"></pdq-input-color>
        </div>

        <div class="appearance-group">
          <p class="appearance-group__title appearance-group__title--sm">Variant selector</p>
          <pdq-radio-group [formControl]="formGroup.get('settings.variantSelector')">
            @for (option of variantSelectorOptions; track option.value) {
              <pdq-radio-button
                [value]="option.value"
                [checked]="formGroup.get('settings.variantSelector')?.value === option.value"
                [text]="option.label"
                [subText]="option.helpText">
              </pdq-radio-button>
            }
          </pdq-radio-group>
        </div>

        <div class="appearance-group">
          <pdq-checkbox
            [formControl]="formGroup.get('settings.showCompareAtPrice')"
            label="Show compare-at price"
            labelSize="small">
          </pdq-checkbox>
        </div>

        <pdq-collapsed class="appearance-collapsible" [initialCollapsed]="false">
          <pdq-collapsed-header arrowStyle="chevron" [arrowInline]="true">
            <span class="appearance-collapsible__title">Button</span>
          </pdq-collapsed-header>
          <pdq-collapsed-content>
            <div class="button-config">
              <div class="button-config__field">
                <div class="button-config__label-row">
                  <span class="button-config__label">Background Color</span>
                  @if (buttonBackgroundOverridden()) {
                    <pdq-link
                      label="Reset to global color"
                      size="small"
                      (onClick)="resetToGlobal(formGroup.get(['settings', 'buttonBackgroundColor']))"></pdq-link>
                  }
                </div>
                <pdq-input-color [formControl]="displayButtonBackground"></pdq-input-color>
              </div>
              <div class="button-config__field">
                <div class="button-config__label-row">
                  <span class="button-config__label">Text Color</span>
                  @if (buttonTextOverridden()) {
                    <pdq-link
                      label="Reset to global color"
                      size="small"
                      (onClick)="resetToGlobal(formGroup.get(['settings', 'buttonTextColor']))"></pdq-link>
                  }
                </div>
                <pdq-input-color [formControl]="displayButtonText"></pdq-input-color>
              </div>
              <div class="button-config__field">
                <div class="button-config__label-row">
                  <span class="button-config__label">Hover Color</span>
                  @if (buttonHoverOverridden()) {
                    <pdq-link
                      label="Reset to global color"
                      size="small"
                      (onClick)="resetToGlobal(formGroup.get(['settings', 'buttonHoverColor']))"></pdq-link>
                  }
                </div>
                <pdq-input-color [formControl]="displayButtonHover"></pdq-input-color>
              </div>
              <div class="button-config__field">
                <div class="button-config__label-row">
                  <span class="button-config__label">Icon Color</span>
                  @if (buttonIconOverridden()) {
                    <pdq-link
                      label="Reset to global color"
                      size="small"
                      (onClick)="resetToGlobal(formGroup.get(['settings', 'buttonIconColor']))"></pdq-link>
                  }
                </div>
                <pdq-input-color [formControl]="displayButtonIcon"></pdq-input-color>
              </div>
              <div class="button-config__field">
                <div class="button-config__label-row">
                  <span class="button-config__label">Corner Radius</span>
                  @if (buttonCornerRadiusOverridden()) {
                    <pdq-link
                      label="Reset to global number"
                      size="small"
                      (onClick)="resetToGlobal(formGroup.get(['settings', 'buttonCornerRadius']))"></pdq-link>
                  }
                </div>
                <pdq-input-arrows
                  [formControl]="displayButtonCornerRadius"
                  [min]="0"
                  [precision]="0"
                  [step]="1"
                  widthSize="fullwidth">
                </pdq-input-arrows>
              </div>
              <pdq-input
                [formControl]="formGroup.get('settings.textAddToOrder')"
                label="Text"
                placeholder="Add to order"
                [invalid]="
                  !!formGroup.get('settings.textAddToOrder')?.invalid &&
                  !!formGroup.get('settings.textAddToOrder')?.touched
                "
                [invalidMsg]="'Button text is required'"></pdq-input>
              <!-- Only relevant to the Popup variant selector (extension parity: variantSelector === 'outside'). -->
              @if (formGroup.get('settings.variantSelector')?.value === 'outside') {
                <pdq-input
                  [formControl]="formGroup.get('settings.variantButtonText')"
                  label="Button Text For Products With Variants"
                  placeholder="Select an option">
                </pdq-input>
              }
            </div>
          </pdq-collapsed-content>
        </pdq-collapsed>

        <pdq-divider></pdq-divider>

        <div class="display-list" cdkDropList (cdkDropListDropped)="dropDisplayText($event)">
          @for (ctrl of additionalDisplayTextsArray.controls; track $index) {
            <div class="display-collapsible" cdkDrag>
              <div class="display-collapsible__header">
                <pdq-icon
                  class="display-collapsible__chevron"
                  icon="arrow_down"
                  [ngClass]="{
                    'display-collapsible__chevron--open': asGroup(ctrl).get('display')?.value,
                  }"></pdq-icon>
                <span class="display-collapsible__title">
                  Display {{ labelForType(asGroup(ctrl).get('type')?.value) | lowercase }}
                </span>
                <div class="display-collapsible__right">
                  <span cdkDragHandle class="drag-handle" aria-hidden="true">
                    @for (dot of dragHandleDots; track $index) {
                      <span></span>
                    }
                  </span>
                  <pdq-slide-toggle [formControl]="asGroup(ctrl).get('display')"></pdq-slide-toggle>
                </div>
              </div>
              @if (asGroup(ctrl).get('display')?.value) {
                <div class="display-collapsible__body">
                  <pdq-input
                    [formControl]="asGroup(ctrl).get('text')"
                    [label]="labelForType(asGroup(ctrl).get('type')?.value) + ' Display Text'"
                    placeholder="{{ '{' }}{{ asGroup(ctrl).get('type')?.value }}{{ '}' }}"
                    [invalid]="!!asGroup(ctrl).errors?.additionalPattern && !!asGroup(ctrl).get('text')?.touched"
                    [invalidMsg]="asGroup(ctrl).errors?.additionalPattern">
                  </pdq-input>
                  <span class="display-collapsible__helper">
                    Use the tag {{ '{' }}{{ asGroup(ctrl).get('type')?.value }}{{ '}' }} to dynamically display the
                    {{ labelForType(asGroup(ctrl).get('type')?.value) | lowercase }}
                  </span>
                </div>
              }
            </div>
          }
        </div>

        <pdq-collapsed class="appearance-collapsible" [initialCollapsed]="false">
          <pdq-collapsed-header arrowStyle="chevron" [arrowInline]="true">
            <span class="appearance-collapsible__title">Design</span>
          </pdq-collapsed-header>
          <pdq-collapsed-content>
            <div class="design-config">
              <div class="design-box">
                <span class="design-box__title">Main Background</span>
                <div class="design-box__row">
                  <pdq-input-color
                    class="design-box__lead"
                    label="Color"
                    [formControl]="formGroup.get('style.mainBackground.color')"
                    [clearable]="true"></pdq-input-color>
                  <pdq-input-arrows
                    class="design-box__num"
                    [formControl]="formGroup.get('style.mainBackground.borderWidth')"
                    label="Border width"
                    [min]="0"
                    [precision]="2"
                    [step]="1"
                    widthSize="fullwidth"></pdq-input-arrows>
                  <pdq-input-arrows
                    class="design-box__num"
                    [formControl]="formGroup.get('style.mainBackground.cornerRadius')"
                    label="Corner Radius"
                    [min]="0"
                    [precision]="2"
                    [step]="1"
                    widthSize="fullwidth"></pdq-input-arrows>
                  <pdq-input-arrows
                    class="design-box__num"
                    [formControl]="formGroup.get('style.mainBackground.innerPadding')"
                    label="Inner Padding"
                    [min]="0"
                    [precision]="2"
                    [step]="1"
                    widthSize="fullwidth"></pdq-input-arrows>
                </div>
              </div>
              <div class="design-box">
                <span class="design-box__title">Product Item</span>
                <div class="design-box__row">
                  <pdq-input-color
                    class="design-box__lead"
                    label="Color"
                    [formControl]="formGroup.get('style.productItem.color')"
                    [clearable]="true"></pdq-input-color>
                  <pdq-input-arrows
                    class="design-box__num"
                    [formControl]="formGroup.get('style.productItem.borderWidth')"
                    label="Border width"
                    [min]="0"
                    [precision]="2"
                    [step]="1"
                    widthSize="fullwidth"></pdq-input-arrows>
                  <pdq-input-arrows
                    class="design-box__num"
                    [formControl]="formGroup.get('style.productItem.cornerRadius')"
                    label="Corner Radius"
                    [min]="0"
                    [precision]="2"
                    [step]="1"
                    widthSize="fullwidth"></pdq-input-arrows>
                  <pdq-input-arrows
                    class="design-box__num"
                    [formControl]="formGroup.get('style.productItem.innerPadding')"
                    label="Inner Padding"
                    [min]="0"
                    [precision]="2"
                    [step]="1"
                    widthSize="fullwidth"></pdq-input-arrows>
                </div>
              </div>
              <div class="design-box">
                <span class="design-box__title">Image</span>
                <div class="design-box__row">
                  <pdq-dropdown
                    class="design-box__lead"
                    [formControl]="formGroup.get('style.image.fit')"
                    title="Fit"
                    [options]="imageFitOptions"
                    optionLabel="label"
                    optionValue="value">
                  </pdq-dropdown>
                  <pdq-input-arrows
                    class="design-box__num"
                    [formControl]="formGroup.get('style.image.borderWidth')"
                    label="Border width"
                    [min]="0"
                    [precision]="2"
                    [step]="1"
                    widthSize="fullwidth"></pdq-input-arrows>
                  <pdq-input-arrows
                    class="design-box__num"
                    [formControl]="formGroup.get('style.image.cornerRadius')"
                    label="Corner Radius"
                    [min]="0"
                    [precision]="2"
                    [step]="1"
                    widthSize="fullwidth"></pdq-input-arrows>
                  <pdq-input-arrows
                    class="design-box__num"
                    [formControl]="formGroup.get('style.image.innerPadding')"
                    label="Inner Padding"
                    [min]="0"
                    [precision]="2"
                    [step]="1"
                    widthSize="fullwidth"></pdq-input-arrows>
                </div>
              </div>
            </div>
          </pdq-collapsed-content>
        </pdq-collapsed>
      </div>
    </pdq-collapsed-content>
  </pdq-collapsed>
</div>
